/** The `create` area: the create forms: a new item, view or group, and the add-
 *  or-create bar. Owned by the stage 2 slot components-a (docs/I18N.md §11). */
export const create = {
  'create.error.unreachable': 'Could not reach the server. Please try again.',
  // The task composer (`CreateTask`, its trigger and the phone's compose bar).
  'create.task.label': 'New item',
  'create.task.placeholder': 'Add an item',
  'create.task.add': 'Add',
  'create.task.retry': 'Not saved. Retry',
  /** A failed optimistic create: the typed title, then the retry button. */
  'create.task.failed': '{title}: {retry}',
  'create.task.unmatched': '{title} is not in this list.',
  // A board's Add bar.
  'create.addBar.placeholder': 'Add or create here…',
  'create.addBar.label': 'Add or create an item on this board',
  'create.addBar.add': 'Add',
  'create.addBar.results': 'Add or create',
  'create.addBar.mutedTitle':
    'You can see this, but adding it here needs owner access to the item.',
  'create.addBar.cantAdd': 'can’t add here',
  'create.addBar.addHint': 'add',
  'create.addBar.createRow': 'Create {title} as a new item',
  'create.addBar.quoted': '“{text}”',
  'create.addBar.newHint': 'new',
  'create.addBar.flowForbidden':
    'Added - but it did not join this board’s flow: you have no write authority on the item.',
  'create.addBar.flowRefused':
    'Added - but it did not join this board’s flow (the flow refused the join).',
  // The new lens / new view dialog.
  'create.view.titleLens': 'New view',
  'create.view.titleView': 'New board',
  'create.view.cancel': 'Cancel',
  'create.view.createLens': 'Create view',
  'create.view.createBoard': 'Create board',
  'create.view.kind': 'Kind',
  'create.view.kindLabel': 'View or board',
  'create.view.lens': 'View',
  'create.view.view': 'Board',
  'create.view.hintLens': 'A saved way of looking. It shows each person what they can see anyway.',
  'create.view.hintView':
    'Holds the work you put on it. Everyone on it sees the same items and can act on them.',
  'create.view.name': 'Name',
  'create.view.namePlaceholderLens': 'View name',
  'create.view.namePlaceholderView': 'Board name',
  'create.view.nameLabelLens': 'New view name',
  'create.view.nameLabelView': 'New board name',
  'create.view.nameMissingLens': 'Give the view a name.',
  'create.view.nameMissingView': 'Give the board a name.',
  // The new group control.
  'create.group.trigger': 'New group',
  'create.group.placeholder': 'Group name',
  'create.group.label': 'New group name',
  'create.error.titleNeeded': 'A task needs a title.',
  'create.error.titleBesidesTags': 'A task needs a title besides its tags.',
  'create.error.groupNameNeeded': 'A group needs a name.',
} as const;
